import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/mocks/site';

function CategoryGrid() {
  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20" aria-label="热点分类">
      <SectionHeading
        eyebrow="分类导航"
        title="按方向找你想追的热点"
        desc="六个方向持续收录，点进去即可看到该方向下全部专题与快讯，还能按状态和热度排序。"
        align="center"
      />

      <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={`/topics?category=${encodeURIComponent(cat.key)}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-2xl text-secondary-800 transition-colors group-hover:bg-primary-100 group-hover:text-primary-800">
              <i className={cat.icon} />
            </span>
            <span className="flex-1">
              <span className="flex items-center gap-2">
                <span className="font-heading text-base font-bold text-foreground-950">
                  {cat.key}热点
                </span>
                <span className="rounded-md bg-background-200/80 px-2 py-0.5 text-xs text-foreground-700">
                  {cat.count} 条
                </span>
              </span>
              <span className="mt-1 block text-sm text-foreground-600">{cat.desc}</span>
            </span>
            <i className="ri-arrow-right-line text-foreground-400 transition-colors group-hover:text-primary-600" />
          </Link>
        ))}
      </div>
    </section>
  );
}

export default CategoryGrid;